import getGlobalConfig from './getGlobalConfig';

export default (state) => getGlobalConfig(state).services;
